import { render, staticRenderFns } from "./ClubSearch.vue?vue&type=template&id=39cd42c2&scoped=true&"
import script from "./ClubSearch.vue?vue&type=script&lang=js&"
export * from "./ClubSearch.vue?vue&type=script&lang=js&"
import style0 from "./ClubSearch.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ClubSearch.vue?vue&type=style&index=1&id=39cd42c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cd42c2",
  null
  
)

export default component.exports